exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.login {\r\n  margin: auto;\r\n  width: 50%;\r\n  padding-top: 50px;\r\n  text-align: center;\r\n}\r\n\r\nsection.login mat-spinner {\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main